export default "__VITE_ASSET__DqmgDrur__"